import React, { useEffect, useState } from 'react';
import { getAllRegisteredUnregisteredClinic } from "../../../../store/slices/clinicSlice";
import { createUnRegisteredClinic, resetUnRegisteredClinicCreateMessage } from "../../../../store/slices/unRegisteredClinic";
import { useDispatch, useSelector } from "react-redux";
import styles from "../editLabReport.module.scss";
import { IoIosAdd } from "react-icons/io";
import ShowTostifyMessageAndReset from "../../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../../common/tostify/Toastifyresponse";

const LabOutsource = ({ handleSelectAllOutsourceToggle, selectAllOutsource, handleGlobalLabChange, globalOutsourceLab,isReceiverClinic}) => {
  const [labSearch, setLabSearch] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [addLabModal, setAddLabModal] = useState(false);
  const [labFormData, setLabFormData] = useState({
    clinicName: "",
    phone: ""
  });
  const dispatch = useDispatch();
  const { registeredUnregisteredClinic, clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const {
    createUnRegisteredClinicSuccessMessage,
    createUnRegisteredClinicErrorMessage,
  } = useSelector((state) => state.unRegisteredClinic);
  const showMessageAndReset = ShowTostifyMessageAndReset();
 const clinicId =clinicInfo?.[0]?.clinicId ||null;
 const clinicObjId = clinicInfo?.[0]?._id;
  useEffect(() => {
    setLabSearch(globalOutsourceLab?.label);
    dispatch(getAllRegisteredUnregisteredClinic({ token,clinicStatus: "Active" }));
  }, [dispatch, globalOutsourceLab, token]);

  useEffect(() => {
    showMessageAndReset(createUnRegisteredClinicSuccessMessage, showToastifySuccess, resetUnRegisteredClinicCreateMessage);
    showMessageAndReset(createUnRegisteredClinicErrorMessage, showToastifyError, resetUnRegisteredClinicCreateMessage);
  }, [createUnRegisteredClinicSuccessMessage, createUnRegisteredClinicErrorMessage, dispatch, showMessageAndReset]);

  const handleLabSearch = (e) => {
    setLabSearch(e.target.value);
    if (e.target.value) {
      dispatch(getAllRegisteredUnregisteredClinic({ searchingFor: e.target.value, clinicStatus: "Active",token }));
    }
  };

  const handleGetAllLabs = () => {
    dispatch(getAllRegisteredUnregisteredClinic({ token,clinicStatus: "Active", }));
    setShowSearch(!showSearch);
  };

  const handleAddNewLab = () => {
    setAddLabModal(true);
    setLabSearch("");
  };

  const handleChangeLabForm = (e) => {
    setLabFormData({ ...labFormData, [e.target.name]: e.target.value });
  };

  const handleSubmitLabForm = async (e) => {
    e.preventDefault();
    await dispatch(createUnRegisteredClinic({ ...labFormData, createdBy:clinicObjId, token }));
    setAddLabModal(false);
    setShowSearch(true);
    await dispatch(getAllRegisteredUnregisteredClinic({ token }));
  };

  const handleCloseLabForm = () => {
    setAddLabModal(false);
    setShowSearch(true);
    dispatch(getAllRegisteredUnregisteredClinic({ token }));
  };

  const handleSelectLab = (item) => {
    handleGlobalLabChange({ value: item._id, label: item?.clinicName, email: item?.clinicEmail });
    setShowSearch(false);
    setLabSearch(item?.clinicName);
    
  };

  
  return (
    <div className="card">
      <div className="card-body d-flex align-items-center gap-3">
        <h5>Select Lab For Outsource :</h5>
        {selectAllOutsource && (
          <div className="form-group position-relative" style={{ width: "22rem", marginTop: "0.5rem" }}>
            <input
              type="search"
              className="form-control"
              placeholder="Enter Lab Name"
              value={labSearch}
              onChange={handleLabSearch}
              onClick={handleGetAllLabs}
             disabled={isReceiverClinic}
            />
            {addLabModal &&
              <div className={styles["addLab"]}>
                <form>
                  <div className="form-group">
                    <input
                      type="text"
                      name="clinicName"
                      className="form-control"
                      placeholder="Lab Name"
                      value={labFormData.clinicName}
                      onChange={handleChangeLabForm}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="number"
                      name="phone"
                      className="form-control"
                      placeholder="Phone Number"
                      value={labFormData.phone}
                      onChange={handleChangeLabForm}
                    />
                  </div>
                  <div className='d-flex justify-content-end'>
                    <button
                      type="button"
                      className={`btn btn-secondary ${styles["button"]}`}
                      onClick={(e) => handleCloseLabForm(e)}
                    >
                      Close
                    </button>
                    <button type="submit" className={`btn btn-success ${styles["button"]}`} onClick={(e) => handleSubmitLabForm(e)}>
                      Save
                    </button>
                  </div>
                </form>
              </div>
            }
            {(labSearch?.length > 0 && registeredUnregisteredClinic?.length < 1) &&
              (<div className={styles["noResultFound"]}>
                <div className={styles['resultWrapper']}>
                  <b>No Result Found</b>
                  <p onClick={handleAddNewLab}> <IoIosAdd /> Add New Lab</p>
                </div>
              </div>)}
            {showSearch &&
              (<div className={registeredUnregisteredClinic?.length > 5 ? styles["searchResultScroll"] : styles["searchResult"]}>
                {registeredUnregisteredClinic && registeredUnregisteredClinic?.map((item) => (
                  <p onClick={() => handleSelectLab(item)}>{item?.clinicName}</p>
                ))}
              </div>)
            }
          </div>
        )}
        <div className="form-check custom-checkbox mb-3 ms-3 checkbox-info mt-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="customCheckBox2"
            name='checkAll'
            checked={selectAllOutsource}
            onChange={handleSelectAllOutsourceToggle}
             disabled={isReceiverClinic}
          />
          <label
            className="form-check-label"
            htmlFor="customCheckBox2"
          >
            Check All Tests To Out Source.
          </label>
        </div>
      </div>
    </div>
  )
}

export default LabOutsource;